import { render, staticRenderFns } from "./plan-affiliations-form.vue?vue&type=template&id=9260c120&scoped=true"
import script from "./plan-affiliations-form.vue?vue&type=script&lang=ts"
export * from "./plan-affiliations-form.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9260c120",
  null
  
)

export default component.exports